/**
 * Checkbox — DS Atom
 */

import styles from './Checkbox.module.css';

interface CheckboxProps {
  label: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
}

export function Checkbox({ label, checked = false, onChange, disabled = false, id, className = '' }: CheckboxProps) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <input
        type="checkbox"
        id={id}
        className={styles.input}
        checked={checked}
        onChange={e => onChange?.(e.target.checked)}
        disabled={disabled}
      />
      <label className={styles.label} htmlFor={id}>{label}</label>
    </div>
  );
}
